import { render, staticRenderFns } from "./OfficeServices.vue?vue&type=template&id=22f9fffc&scoped=true&"
import script from "./OfficeServices.vue?vue&type=script&lang=js&"
export * from "./OfficeServices.vue?vue&type=script&lang=js&"
import style0 from "./OfficeServices.vue?vue&type=style&index=0&id=22f9fffc&lang=scss&scoped=true&"
import style1 from "./OfficeServices.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f9fffc",
  null
  
)

export default component.exports